import { SEOHead } from "@/components/seo/SEOHead.tsx";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button.tsx";

export function NotFoundPage() {
  return (
    <>
      <SEOHead title="Page Not Found" description="This page doesn't exist." path="/404" noindex={true} />
      <div className="min-h-screen bg-surface-50 flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <p className="text-7xl font-bold text-surface-200 mb-4">404</p>
        <h1 className="text-xl font-semibold text-surface-900 mb-2">Page not found</h1>
        <p className="text-[13px] text-surface-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => window.history.back()}>Go back</Button>
          <Link to="/dashboard"><Button>Dashboard</Button></Link>
        </div>
      </div>
    </div>
    </>
  );
}
